module.exports = __webpack_public_path__ + "static/media/4.c72196e1.jpg";